type CaseFollowUpKinds = {
  [key: string]: {
    color: string
    name: string
  }
}

type CaseFollowUpKindsOptions = {
  value: string
  label: string
  color: string
}

export const MODULES_KINDS_OPTIONS: CaseFollowUpKindsOptions[] = [
  { value: 'ACTIVITY', label: 'Atividades', color: 'blue' },
  { value: 'ALERT', label: 'Alertas', color: 'green' },
  //  { value: 'CASE_TRACKING', label: 'Acompanhamentos de casos', color: 'red' },
  { value: 'REVIEW_ANSWER', label: 'Avaliação', color: 'emerald' },
  { value: 'ACTIVITY_PLANNING', label: 'Atividades planejadas', color: 'purple' },
  { value: 'SERVICE_REQUEST', label: 'Encaminhamentos', color: 'cyan' },
  { value: 'SURVEY_ANSWER', label: 'Pesquisa', color: 'yellow' },
]

export const MODULES_KIND_OBJECT: CaseFollowUpKinds = {
  ACTIVITY: {
    color: 'blue',
    name: 'Atividade',
  },
  CASE_TRACKING: {
    color: 'red',
    name: 'Acompanhamentos de casos',
  },
  ALERT: {
    color: 'green',
    name: 'Alerta',
  },
  REVIEW: {
    color: 'blue',
    name: 'Avaliação',
  },
  ACTIVITY_PLANNING_ACTIVITY_TYPE: {
    color: 'purple',
    name: 'Atividade planejada',
  },
  ACTIVITY_PLANNING_ROLE: {
    color: 'purple',
    name: 'Atividade planejada',
  },
  REVIEW_ANSWER: {
    color: 'emerald',
    name: 'Avaliação',
  },
  SERVICE_REQUEST: {
    color: 'cyan',
    name: 'Encaminhamento',
  },
  SURVEY_ANSWER: {
    color: 'yellow',
    name: 'Pesquisa',
  },
  UNKNOWM: {
    color: 'gray',
    name: 'Desconhecido',
  },
}
